/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - David Pistori <dp@indigen.com>
 *   - Loay Hatem <lh@indigen.com>
 *   - Peter Magdy <pm@indigen.com>
 * NOTICE: All information contained here is, and remains
 * the property of Indigen Solutions and its suppliers, if any.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import * as React from "react";
import "./PWA.css";
import RoseLem from "./lems/RoseLem";
import SafariDownloadIcon from "./icons/SafariDownloadIcon";
import ChromeDownloadIcon from "./icons/ChromeDownloadIcon";
import SamsungDownloadIcon from "./icons/SamsungDownloadIcon";

export interface PWAState {
  browserName: string;
}
export default class PWA extends React.Component<{}, PWAState> {
  constructor(props) {
    super(props);
    this.state = { browserName: "samsung" };
  }
  componentDidMount() {
    let userAgent = navigator.userAgent;
    let browserName;
    console.log(userAgent);
    if (userAgent.match(/samsung/i)) {
      browserName = "samsung";
    } else if (userAgent.match(/chrome|chromium|crios|firefox|fxios/i)) {
      browserName = "chrome";
    } else if (userAgent.match(/safari/i)) {
      browserName = "safari";
    }
    this.setState({ browserName });
  }

  render() {
    return (
      <div className="pwaOverlay">
        <div
          className="pwaImage"
          style={{
            backgroundImage: `url("/images/pwaTutorial/pwaScreen.png")`,
          }}
        />
        <div className="pwaLem">
          <RoseLem />
        </div>
        <div className="pwaCard">
          <div
            className="pwaCardImage"
            style={{
              backgroundImage: `url("/images/pwaTutorial/pwaCard.png")`,
            }}
          />

          <div className="title">Installer Mymonop</div>
          <div className="subTitle">
            Installer l’application Mymonop sur votre téléphone pour y accéder
            facilement.
          </div>
          {this.state.browserName === "safari" && this._renderSafariTutorial()}
          {this.state.browserName === "chrome" && this._renderChromeTutorial()}
          {this.state.browserName === "samsung" &&
            this._renderSamsungTutorial()}
        </div>
      </div>
    );
  }

  private _renderSafariTutorial() {
    return (
      <div>
        <div className="text">
          Cliquer sur
          <span>
            <SafariDownloadIcon />
          </span>
          en bas de votre écran
        </div>
        <div className="text">Puis sélectionner “Sur l’écran d’accueil”</div>
      </div>
    );
  }

  private _renderChromeTutorial() {
    return (
      <div>
        <div className="text">
          Cliquer sur
          <span style={{ marginTop: "5px" }}>
            <ChromeDownloadIcon />
          </span>
          en haut à droite de votre écran
        </div>
        <div className="text">
          Puis sélectionner “Ajouter à l'écran d'accueil”
        </div>
      </div>
    );
  }

  private _renderSamsungTutorial() {
    return (
      <div>
        <div className="text">
          Cliquer sur
          <span style={{ marginTop: "5px" }}>
            <SamsungDownloadIcon />
          </span>
          en bas à droite de votre écran
        </div>
        <div className="text">
          Puis sélectionner “Ajouter à l'écran d'accueil”
        </div>
      </div>
    );
  }
}
